import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
export function Heritage() {
  return <section aria-labelledby="heritage-heading" className="w-full border-t border-rule bg-warm" data-id="element-101" data-mp="12alityyu8drq">
      <div className="mx-auto grid max-w-shell gap-10 px-5 py-16 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-20 lg:px-10 lg:py-24" data-id="element-102" data-mp="171txb9f0ypbr">
        <SectionHeading id="heritage-heading" eyebrow="ENGINEERING ROOTS" heading="A cutting-tool system shaped by precision-machining experience" data-id="element-103" data-mp="1bzvchj9by4hy" />
        <div className="self-center" data-id="element-104" data-mp="1lzw21mxslgul">
          <p className="rp-measure text-[15.5px] leading-[1.7] text-graphite/85" data-id="element-105" data-mp="1lwqc65hcaaxt">
            Shear Geometry grew out of Robertson Precision’s hands-on experience
            machining demanding materials and controlling the cut. The result is
            a compact system of holders, replaceable inserts and application
            guidance for CNC lathes.
          </p>
          <p className="rp-measure mt-6 border-l border-rule pl-5 text-[14px] leading-[1.7] text-graphite/70" data-id="element-106" data-mp="yuo1zmicxclc">
            Federal SBIR records document Robertson Precision’s historic R&amp;D
            on automated production of high-precision copper accelerator cells
            in 1998 and 1999. That hands-on technical history remains part of
            the Shear Geometry story.
          </p>
          <Link to="/company-history/" className="mt-8 inline-flex min-h-[44px] items-center gap-2 border-b border-copper text-[14px] font-semibold text-navy transition-colors duration-150 ease-precise hover:text-copper" data-id="element-107" data-mp="1hrgz5tunaxky">
            Read the Company History
            <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-108" data-mp="12u6o2llwztpr" />
          </Link>
        </div>
      </div>
    </section>;
}